import React, { useEffect } from 'react';

import { userApis } from '@apis/userApis';
import bgLogin from '@assets/img/arts/bg-login.png';
import { Button } from '@components/Button';
import { Dialog } from '@components/Dialog';
import { Layout } from '@components/Layout';
import { SpinnerModal } from '@components/SpinnerModal';
import { useMutation } from '@hooks/useMutation';
import { useSearch } from '@hooks/useSearch';
import { makeMuiStyles, useCommonStyles } from '@styles';
import { FormError } from '@utils/errors';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';
import * as t from 'io-ts';
import { useHistory } from 'react-router-dom';

const strings = createStrings({
  ja: {
    title: 'ログイン',
    verificationFailed: '申し訳ございませんが、メールアドレスの検証が失敗しました。',
    goBack: 'TOPへ',
  },
});

const useStyles = makeMuiStyles((theme, common) => ({
  container: {
    ...common.backgroundCenter,
    flex: 1,
    backgroundImage: `url(${bgLogin})`,
  },
  inner: {
    maxWidth: 680,
    margin: '0 auto',
    padding: '0 1rem',
  },
  logo: {
    display: 'block',
    width: 130,
    height: 30,
    alignSelf: 'center',
    marginBottom: 50,
  },
  helpContainer: {
    ...common.flexInline,
    justifyContent: 'space-between',
  },
  helpLink: {
    ...common.baseButton,
    ...common.middleText,
    '&:hover': {
      color: theme.palette.primary.main,
    },
  },
  paper: {
    textAlign: 'center',
    whiteSpace: 'pre',
  },
}));

const query = t.type({
  key: t.string,
});

export const ConfirmEmail: React.FC = () => {
  const classes = {
    ...useCommonStyles(),
    ...useStyles(),
  };

  const history = useHistory();

  const { search } = useSearch(query);

  const verifyEmail = useMutation(async () => {
    const result = await userApis.post('/registration/verify-email/', {
      body: {
        key: search.key,
      },
    });

    if (result[200]) {
      history.push('/auth/Login?emailVerified=true');
    } else {
      throw new FormError('VerifyEmail', result.response as any);
    }
  });

  useEffect(() => {
    verifyEmail.mutate();
  }, []);

  const renderModal = () => (
    <Dialog
      open={verifyEmail.isError}
      classes={{
        paper: classes.paper,
      }}
    >
      {strings.verificationFailed}
      <br />
      <br />
      <br />
      <Button
        color="primary"
        text={strings.goBack}
        style={{ alignSelf: 'center', width: 120 }}
        onClick={() => history.push('/auth/Login?emailVerified=false')}
      />
    </Dialog>
  );

  return (
    <Layout title={strings.title}>
      <SpinnerModal open={verifyEmail.isLoading} />
      <div className={classes.container} />
      {renderModal()}
    </Layout>
  );
};

export const meta: PageMeta = {};
